// extracted by mini-css-extract-plugin
export var copyableItem = "_j-0";
export var underlined = "_j-1";